/* Quwat pd- section behavior. Namespaced as QW.
   Cart logic (QW.cart, QW.addToCart, QW.selectVariant, QW.adjustQty)
   lives in snippets/pd-cart-drawer.liquid — do NOT redefine it here. */
window.QW = window.QW || {};

(function () {
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function toggleFaq(btn) {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    var answer = btn.parentElement.querySelector('.pd-faq-item__answer');
    if (answer) answer.hidden = expanded;
  }

  function scrollToBuy() {
    var el = $('#buy-section') || $('#pd-product');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function selectPlanAndScroll(variantId) {
    var card = $('.pd-plan-card[data-variant-id="' + variantId + '"]');
    if (card && window.QW.selectVariant) window.QW.selectVariant(card);
    scrollToBuy();
  }

  window.QW.toggleFaq = toggleFaq;
  window.QW.scrollToBuy = scrollToBuy;
  window.QW.selectPlanAndScroll = selectPlanAndScroll;
})();